<style scoped>
img {
  width:60%

}

</style>

<template>
  <v-stepper 
    alt-labels
    v-model="step" 
    style="height:100%;overflow-y:scroll;overflow-x:scroll;" 
    class="elevation-0 "
  >
    <v-stepper-header>
      <v-stepper-step :complete="step>1" step="1">Device parameters</v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step :complete="step>2" step="2">Sigfox backend</v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step  :complete="step>3" step="3">Config dashboard</v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step  step="4">Register device</v-stepper-step>
      <v-divider></v-divider>
    </v-stepper-header>

    <v-stepper-items class="subheading text-xs-left ">
      <v-btn fab dark color="#FFD300" style="color:#002052;position:absolute;right:0;margin-top:1.5rem;z-index:10" @click="step++; step = (step==5)?1:step">
        <v-icon dark>fast_forward</v-icon>
      </v-btn>
      <v-btn fab dark color="#FFD300" style="color:#002052;position:absolute;right:0;bottom:0;z-index:10" @click="step++; step = (step==5)?1:step">
        <v-icon dark>fast_forward</v-icon>
      </v-btn>

      <v-stepper-content step="1" >
        <v-card>
          <v-card-title style="background-color:#39a9dc">
            <h2 class="title white--text font-weight-light">Get device parameters</h2>
          </v-card-title>
          <v-container>
            <v-layout>
                <v-layout row wrap>
                  <v-flex xs12>
                  <b>a</b>. Connect device to the PC via USB, flash FP-ATR-SIGFOX binary file and reboot.
                  </v-flex>
                  <v-flex xs12>
                  <b>b</b>. Open serial terminal (e.g. TeraTerm) to inspect device log
                  </v-flex>
                  <v-flex xs12>
                    <img
                      style="" 
                      src="@/assets/howto/serialportsetup.png" />
                  </v-flex>
                  <v-flex xs12>
                  <b>c</b>. From serial terminal, get <b> device ID and PAC</b>
                  </v-flex>
                </v-layout>
            </v-layout>
          </v-container>
        </v-card>
      </v-stepper-content>

      <v-stepper-content step="2">
        <v-card>
          <v-card-title  style="background-color:#39a9dc">
            <v-icon
              dark
              size="42"
              class="mr-3"
            >
              mdi-magnify
            </v-icon>
            <h2 class="title white--text font-weight-light">Sigfox backend</h2>
          </v-card-title>
          <v-container>
            <v-layout row wrap>
              <v-flex xs12>
                <b>a</b>. Activate device from Sigfox <a href="https://buy.sigfox.com/activate">activation page</a>
              </v-flex>
              <v-flex xs12>
                <b>b</b>. Login in your Sigfox <a href="https://backend.sigfox.com/auth/login">backend account</a>
              </v-flex>
              <v-flex xs12>
                <b>c</b>. Create a new API ACCESS (with all permissions) under device group created at activation time
              </v-flex>
              <v-flex xs12>
                <b>d</b>. Get credentials (Login and Password) automatically generated
              </v-flex>
              <v-flex xs12 style=";text-align:center" >
                <img
                style=" ;text-align:center" 
                src="@/assets/howto/sigfoxcreategroup.png" />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-stepper-content>


      <v-stepper-content step="3">
        <v-card>
          <v-card-title style="background-color:#39a9dc">
            <v-icon
              class="mr-3"
              dark
              size="42"
            >
              mdi-email-outline
            </v-icon>
            <h2 class="title white--text font-weight-light">Configure asset-tracking dashboard</h2>
          </v-card-title>
          <v-container>
            <v-layout  row wrap>
              <v-flex xs12>
                  <b>a</b>. Create and get an api-key from <a v-on:click="$emit('routing', {name:'settings'})">settings</a> view
                </v-flex>
                <v-flex xs12 style=";text-align:center" >
                  <img
                  style=" ;text-align:center" 
                  src="@/assets/howto/assettrackingapikey.png" />
                </v-flex>
              <v-flex xs12>
                <b>b</b>. In order to simplify the device provisioning, create a Sigfox device profile from <a v-on:click="$emit('routing', {name:'settings'})">settings</a> view. Use Login and Password parameters got previously  
              </v-flex>
              <v-flex xs12 style="text-align:center">
                <img style="" src="@/assets/howto/assettrackingsigfoxdeviceprofile.png" />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-stepper-content>


      <v-stepper-content step="4">
        <v-card>
          <v-card-title style="background-color:#39a9dc">
            <v-icon
              class="mr-3"
              dark
              size="42"
            >
              mdi-email-outline
            </v-icon>
            <h2 class="title white--text font-weight-light">Register device</h2>
          </v-card-title>
          <v-container>
            <v-layout row wrap>
                <v-flex xs12 >
                  Register device with:
                  <ul>
                    <li>human-friendly label</li>
                    <li>device ID and PAC (got previously)</li>
                    <li>device profile (default or the previous one created)</li>
                  </ul>
                </v-flex>
                <v-flex xs12  style="text-align:center">
                  <img style="" src="@/assets/howto/registersigfoxdevice.png" />
                </v-flex>
              </v-layout>
          </v-container>
        </v-card>
      </v-stepper-content>


    </v-stepper-items>
  </v-stepper>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(
      {
          http: state => state.metadata.backendApi.http[state.metadata.env]
      }
    )
  },
  data(){
    return {
      step: 0
    }
  }
}
</script>